/* unplugin-vue-components disabled */import { render } from "./icon_profile.vue?vue&type=template&id=707bf77b&scoped=true"
const script = {}

import "./icon_profile.vue?vue&type=style&index=0&id=707bf77b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707bf77b"]])

export default __exports__